module.exports = __webpack_public_path__ + "img/page-28.cbda76b1.jpg";